export default "__VITE_ASSET__Tz7KvKld__"